<template>
  <div class="product-gallery" v-if="images">
    
    <div class="feature" 
     :style="`background: url(${firstImage.url}) no-repeat center center / cover; 
                          flex-basis:${(100 / (images.length - 1))}%;
                          background-size:${!isZooming ? 'cover' : '300%'};
                          background-position:${x}% ${y}%`"
      @mouseover="isZooming = true"
      @mousemove="zoomOnCursor($event)" 
      @mouseleave="isZooming = false; x=50; y=50;"
      >
     
    </div>
    <div class="additional-images">
      <div class="image" v-for="image in images" 
        :style="`background: url(${image.url}) no-repeat center center / cover; 
                             flex-basis:calc(${(100 / (images.length))}% - 2.5px);
                             padding-bottom:${(100 / (images.length))}%;
                             `" 
        :key="image.ID" 
        @click="switchImage(image)"
        @mouseover="switchImage(image)"
        
        :src="image.url" 
        :alt="image.alt" ></div>
    </div>
  </div>
</template>


<script>
  import axios from 'axios';
  export default {
    data: function () {
      return {
        message: 'Hello World!',
        images: [],
        firstImage: {},
        additionalImages: {},
        isZooming: false,
        x: 0,
        y: 0
      };
    },
    props: ['imageurls'],
    methods: {
      async sample() {
        const { data } = await axios.get(``);
      },

      switchImage(image) {
        this.firstImage = image;
      },

      zoomOnCursor(event) {
        var height = event.toElement.clientHeight;
        var width = event.toElement.clientWidth;
        this.x = event.offsetX / width  * 100;
        this.y = event.offsetY / height * 100;
      }
      
    },
    computed: {
    },
    async mounted() {
      this.images = JSON.parse(this.imageurls);
      this.firstImage = this.images[0];
    }
  }

</script>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/ProductGallery.vue